import React from "react";
import { observer } from "mobx-react";
import { OrbitComponent } from "../../base-components/orbit-component/orbit-component";
import { SideMenuItemBox } from "./boxes/side-menu-item.box";
import { CyClass } from "../../../../common/cy-classes";

interface SideMenuItemProps {
    itemId: string;
}

@observer
export class SideMenuItem extends OrbitComponent<SideMenuItemProps> {
    render() {
        const config = this.getConfig();
        if (!config.display) {
            return null;
        }
        return <SideMenuItemBox hidden={config.hideElement} className={CyClass("cy-menu-item")}>
            { this.props.children }
        </SideMenuItemBox>;
    }

    private getConfig() {
        return this.services.configuration.data.sideMenu.menu_links[this.props.itemId];
    }

}
